import styled from 'styled-components'
import { ResponsiveImage } from '../../ResponsiveImage/ResponsiveImage'

export const BlocksGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  & > div {
    &:nth-child(1) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem0;
    }

    &:nth-child(2) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem1;
    }

    &:nth-child(3) {
      grid-area: LookbookBlockItem2;
    }
  }

  @media screen and (min-width: 768px) {
    display: grid;
    width: 100%;
    grid-template-columns: 25% auto;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'LookbookBlockItem0 LookbookBlockItem2'
      'LookbookBlockItem1 LookbookBlockItem2';
  }
`

export const SquareImage = styled(ResponsiveImage)`
  object-fit: cover;
  height: 100%;
  aspect-ratio: 1;
`

export const RectangleImage = styled(ResponsiveImage)`
  object-fit: cover;
  height: 100%;
  aspect-ratio: 3/2;
`
